export const CARD_EXPIRATION_DATE_FIELD_NAME = 'cardExpirationDate';

export const MAX_EXPIRATION_DATE_LENGTH = 5;
